module.exports = __webpack_public_path__ + "static/media/collapse.26e88d62.svg";